import React, { Component } from "react"
import PropTypes from "prop-types"
import { select } from "d3-selection"

class LineViz extends Component {
  componentDidMount() {
    this.drawLine()
  }

  componentDidUpdate() {
    this.drawLine(true)
  }

  drawLine(update = false) {
    const {
      data,
      colorArr,
      color,
      scoreLine,
      offsets,
      gradientId,
      svgHeight
    } = this.props

    // Resetting line for update
    if (update) {
      select(this.lineG)
        .selectAll("linearGradient")
        .remove()
      select(this.lineG)
        .selectAll("stop")
        .remove()
      select(this.lineG)
        .selectAll("path")
        .remove()
    }

    // Add the line
    select(this.lineG)
      .append("path")
      .datum(data)
      .attr("d", scoreLine)
      .attr("fill", "none")
      .attr("stroke", () => (colorArr ? `url(#${gradientId})` : color))
      .attr("stroke-width", "2px")
      .attr("class", "line")

    // Add the linear gradient
    if (colorArr) {
      select(this.lineG)
        .append("linearGradient")
        .attr("id", gradientId)
        .attr("gradientUnits", "userSpaceOnUse")
        .attr("x1", 0)
        .attr("y1", svgHeight)
        .attr("x2", 0)
        .attr("y2", 0)
        .selectAll("stop")
        .data(offsets)
        .enter()
        .append("stop")
        .attr("offset", d => d.offset)
        .attr("stop-color", d => d.color)
    }
  }

  render() {
    const {
      classes,
      translate,
      colorArr,
      color,
      showEndScore,
      finalY,
      scaledFinalX,
      scaledFinalY,
      gradientId
    } = this.props

    return (
      <g
        className={classes}
        ref={el => (this.lineG = el)}
        transform={translate}
      >
        {showEndScore && (
          <g>
            <circle
              fill={`url(#${gradientId})`}
              cx={scaledFinalX}
              cy={scaledFinalY}
              r="4"
            />
            <text
              x={scaledFinalX - 3}
              y={scaledFinalY - 10}
              fontSize="12px"
              fontWeight="bold"
              fill={colorArr ? `url(#${gradientId})` : color}
              className="current-score-text"
            >
              {finalY}
            </text>
          </g>
        )}
      </g>
    )
  }
}

export default LineViz

LineViz.propTypes = {
  scoreLine: PropTypes.string.isRequired,
  offsets: PropTypes.arrayOf(
    PropTypes.shape({
      offset: PropTypes.string,
      color: PropTypes.string
    })
  ).isRequired,
  svgHeight: PropTypes.number.isRequired,
  finalY: PropTypes.number.isRequired,
  scaledFinalX: PropTypes.number.isRequired,
  scaledFinalY: PropTypes.number.isRequired,
  classes: PropTypes.string,
  translate: PropTypes.string,
  colorArr: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  showEndScore: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.object,
      score: PropTypes.number
    })
  ),
  gradientId: PropTypes.string
}

LineViz.defaultProps = {
  classes: "line",
  translate: "translate(0, 0)",
  colorArr: ["black"],
  color: "black",
  showEndScore: true,
  data: [{ date: new Date(), trainees: 0, score: 0 }],
  gradientId: "line-gradient"
}
